import { connect } from 'react-redux';
import CurriculumModal from '../../components/curriculum/CurriculumModal';
import * as actions from '../../actions/schedule';

const mapStateToProps = ({ schedule }) => ({
  plan: schedule.plan,
  isLoading: schedule.isLoading,
});

const mapDispatchToProps = dispatch => ({
  getPlan: id => dispatch(actions.getPlan(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CurriculumModal);
